import React from 'react'

// components
import {
  CRow,
  CCol,
  CFormLabel
} from '@coreui/react-pro'
import FormTextInput from '../general-input-form/FormTextInput'
import FormTextAreaInput from '../general-input-form/FormTextAreaInput'
import FormPrice from '../general-input-form/FormPrice'
import FormDatePicker from '../general-input-form/FormDatePicker'
import FormSelectInput from '../general-input-form/FormSelectInput'
import FormSwitchInput from '../general-input-form/FormSwitchInput'
import FormFileUpload from '../general-input-form/FormFileUpload'
import FormFileThumbnail from '../general-input-form/FormFileThumbnail'
import FormInvoiceRecipients from '../general-input-form/FormInvoiceRecipients'
import FormInvoiceFormat from '../general-input-form/FormInvoiceFormat'
import FormInvoicingTermsCondition from '../general-input-form/FormInvoicingTermsCondition'

const AppForm = ({
  values,
  handleChange,
  onDateChange,
  errors,
  projectOptions,
  handleSelectProject,
  isShowDropdown,
  handleFileInput,
  handleViewFile,
  handleConfirmDelete,
  handleAddInvoiceRecipients,
  handleChangeInvoiceRecipients,
  handleSelectCountryInvoiceRecipients,
  handleRemoveInvoiceRecipients,
  countryOptions,
  clientOptions,
  handleSelectClient,
  handleSearchInput,
  handleSearchProject,
  handleCheckbox,
  handleChangeShippingDetail,
  handleDateChangeShippingDetail,
  courierOptions,
  handleSelectCourier,
  isFromModal = false,
  handleSelectPic,
  picList = [],
  picValue,
  handleShowModalCreate
}) => {
  let isShowFileShipping = false
  let isShowDocumentSubmission = false

  if (
    values.invoice_shipping_detail.is_soft_copy ||
    values.invoice_shipping_detail.is_hard_copy
  ) {
    isShowFileShipping = true
    isShowDocumentSubmission = true
  }

  return (
    <>
      {/* ========== Section 1: Invoice Name, Value, Tax ========== */}
      <CRow className="mb-2 g-2">
        <CCol xs="12" sm="6" md="6">
          <FormTextInput 
            id='invoice_name'
            name='invoice_name'
            colSize='12'
            inputLabel='Invoice Name'
            className='mb-3'
            placeholder='Enter invoice name...'
            value={values.invoice_name}
            handleTextInput={handleChange}
            feedbackInvalid={errors?.invoice_name}
            invalid={errors?.invoice_name}
          />
        </CCol>
        <CCol xs="12" sm="6" md="3">
          <FormPrice
            id='invoice_value'
            name='invoice_value'
            colSize='12'
            className='mb-3'
            inputLabel='Invoice Value'
            placeholder='Enter invoice value...'
            value={values.invoice_value}
            handlePriceInput={handleChange}
            feedbackInvalid={errors?.invoice_value}
            invalid={errors?.invoice_value}
          />
        </CCol>
        <CCol xs="12" sm="6" md="3">
          <FormPrice
            id='invoice_tax_value'
            name='invoice_tax_value'
            colSize='12'
            className='mb-3'
            inputLabel='Tax and other fees'
            placeholder='Enter invoice tax and other fees...'
            value={values.invoice_tax_value}
            handlePriceInput={handleChange}
            feedbackInvalid={errors?.invoice_tax_value}
            invalid={errors?.invoice_tax_value}
          />
        </CCol>
      </CRow>

      {/* ========== Section 2: Description & Date Pickers in 2 Columns ========== */}
      <CRow className="mb-2 g-2">
        {/* Left Column: Invoice Description (6 kolom) */}
        <CCol xs="12" md="6">
          <FormTextAreaInput
            id='invoice_description'
            name='invoice_description'
            colSize='12'
            inputLabel='Invoice Description'
            className='mb-3'
            placeholder='Enter invoice description...'
            rows='5'
            value={values.invoice_description}
            handleTextAreaInput={handleChange}
            feedbackInvalid={errors?.invoice_description}
            invalid={errors?.invoice_description}
          />
        </CCol>

        {/* Middle Column: Date Pickers 1 (3 kolom) */}
        <CCol xs="12" sm="6" md="3" className='py-2'>
          <FormDatePicker 
            id='invoice_due_date'
            name='invoice_due_date'
            colSize='12'
            inputLabel='Invoice Due Date'
            className='mb-3'
            handleOnDateChange={onDateChange}
            value={values.invoice_due_date}
            feedbackInvalid={errors?.invoice_due_date}
            invalid={errors?.invoice_due_date}
          />
          <FormDatePicker 
            id='invoice_expected_payment_date'
            name='invoice_expected_payment_date'
            colSize='12'
            inputLabel='Invoice Expected Payment Date'
            className='mb-3'
            handleOnDateChange={onDateChange}
            value={values.invoice_expected_payment_date}
            feedbackInvalid={errors?.invoice_expected_payment_date}
            invalid={errors?.invoice_expected_payment_date}
          />
        </CCol>

        {/* Right Column: Date Pickers 2 (3 kolom) */}
        <CCol xs="12" sm="6" md="3" className='py-2'>
          <FormDatePicker 
            id='invoice_tax_due_date'
            name='invoice_tax_due_date'
            colSize='12'
            inputLabel='Invoice Tax Due Date'
            className='mb-3'
            handleOnDateChange={onDateChange}
            value={values.invoice_tax_due_date}
            feedbackInvalid={errors?.invoice_tax_due_date}
            invalid={errors?.invoice_tax_due_date}
          />
        </CCol>
        <FormSelectInput 
          id='client_value'
          name='client_value'
          colSize='6'
          inputLabel='Client Name'
          className='mb-3'
          selectOptions={clientOptions}
          value={values?.client_value}
          handleSelectInput={handleSelectClient}
          feedbackInvalid={errors.client_value || errors.client_value?.name}
          invalid={errors.client_value || errors.client_value?.name}
          disabled={isFromModal}
          isShowCreatedModal={true}
          handleSearchInput={handleSearchInput}
          handleShowModalCreate={handleShowModalCreate}
          placeholder='Select client...'
        />
        <FormSelectInput 
          id='project_value'
          name='project_value'
          colSize='6'
          inputLabel='Project Name'
          className='mb-3'
          selectOptions={projectOptions}
          value={values?.project_value}
          handleSelectInput={handleSelectProject}
          feedbackInvalid={errors.project_value || errors.project_value?.name}
          invalid={errors.project_value || errors.project_value?.name}
          disabled={isFromModal || !values?.client_value?.value}
          isShowCreatedModal={true}
          handleSearchInput={handleSearchProject}
          handleShowModalCreate={handleShowModalCreate}
          placeholder={values?.client_value?.value ? 'Select project...' : 'Please select client first'}
        />
        <CRow className="mb-2 g-2">
          <FormSwitchInput 
            id='invoice_is_paid'
            name='invoice_is_paid'
            colSize='12'
            inputLabel='Paid?'
            className='mb-2'
            handleSwitch={handleChange}
            value={values.invoice_is_paid}
            invalid={errors?.invoice_is_paid}
          />
        </CRow>
        {
          values?.invoice_is_paid && (
            <CCol xs="12" md="6" className='py-2'>
              <FormDatePicker 
                id='invoice_payment_date'
                name='invoice_payment_date'
                colSize='12'
                inputLabel='Invoice Payment Date'
                className='mb-3'
                handleOnDateChange={onDateChange}
                value={values.invoice_payment_date}
                feedbackInvalid={errors?.invoice_payment_date}
                invalid={errors?.invoice_payment_date}
              />
            </CCol>
          )
        }
      </CRow>

      {/* ========== Section 4: Bukti Potong PPh 23 ========== */}
      <CRow className="mb-2 g-2">
        <CCol xs="12" md="6">
          <FormSwitchInput 
            id='invoice_bupot_required'
            name='invoice_bupot_required'
            colSize='12'
            inputLabel='Bukti potong PPh 23'
            className='mb-2'
            handleSwitch={handleChange}
            value={values.invoice_bupot_required}
            invalid={errors?.invoice_bupot_required}
          />
        </CCol>
        {
          values?.invoice_bupot_required && (
            <CCol xs="12" md="6" className='py-2'>
              {values?.file_bupot?.length > 0 ? (
                <>
                  <CFormLabel>
                    Document bukti potong PPh 23
                  </CFormLabel>
                  <FormFileThumbnail 
                    name='file_bupot'
                    colSize='12'
                    files={values.file_bupot}
                    className='justify-content-start align-items-center'
                    handleViewFile={handleViewFile}
                    handleConfirmDelete={handleConfirmDelete}
                  />
                </>
              ) : (
                <FormFileUpload
                  name='file_bupot'
                  colSize='12'
                  handleFileInput={handleFileInput}
                  handleFileOnDrop={handleFileInput}
                  inputLabel='Document bukti potong PPh 23'
                  multiple={false}
                  feedbackInvalid={errors?.file_bupot}
                  invalid={errors?.file_bupot}
                  isSpesificImage={false}
                  maxFiles={1}
                />
              )}
            </CCol>
          )
        }
      </CRow>

      {/* ========== Section 5: Faktur Pajak ========== */}
      <CRow className="mb-2 g-2">
        <CCol xs="12" md="6">
          <FormSwitchInput 
            id='invoice_faktur_required'
            name='invoice_faktur_required'
            colSize='12'
            inputLabel='Faktur pajak'
            className='mb-2'
            handleSwitch={handleChange}
            value={values.invoice_faktur_required}
            invalid={errors?.invoice_faktur_required}
          />
        </CCol>
        {
          values?.invoice_faktur_required && (
            <CCol xs="12" md="6">
              {values?.file_faktur?.length > 0 ? (
                <>
                  <CFormLabel>
                    Document faktur pajak
                  </CFormLabel>
                  <FormFileThumbnail 
                    name='file_faktur'
                    colSize='12'
                    files={values.file_faktur}
                    className='justify-content-start align-items-center'
                    handleViewFile={handleViewFile}
                    handleConfirmDelete={handleConfirmDelete}
                  />
                </>
              ) : (
                <FormFileUpload
                  name='file_faktur'
                  colSize='12'
                  handleFileInput={handleFileInput}
                  handleFileOnDrop={handleFileInput}
                  inputLabel='Document faktur pajak'
                  multiple={false}
                  feedbackInvalid={errors?.file_faktur}
                  invalid={errors?.file_faktur}
                  isSpesificImage={false}
                  maxFiles={1}
                />
              )}
            </CCol>
          )
        }
      </CRow>

      {/* ========== Section 6: Invoice Number & Draft ========== */}
      <CRow className="mb-2 g-2">
        <CCol xs="12" md="6" className='py-2'>
          <FormTextInput 
            id='invoice_number'
            name='invoice_number'
            colSize='12'
            inputLabel='Invoice Number'
            className='mb-3'
            placeholder='Auto generate invoice number'
            value={values.invoice_number}
            handleTextInput={handleChange}
            feedbackInvalid={errors?.invoice_number}
            invalid={errors?.invoice_number}
            disabled={true}
          />
        </CCol>
        <CCol xs="12" md="6" className='py-2'>
          <FormSwitchInput 
            id='invoice_is_draft'
            name='invoice_is_draft'
            colSize='12'
            inputLabel='Draft?'
            className='mb-3'
            handleSwitch={handleChange}
            value={values.invoice_is_draft}
            invalid={errors?.invoice_is_draft}
          />
        </CCol>
      </CRow>

      {/* ========== Section 7: Invoice Format ========== */}
      <CRow className="mb-4 g-3">
        <FormInvoiceFormat 
          id='invoice_shipping_detail'
          type={'checkbox'}
          colSize='12'
          className='mb-3'
          inputLabel='Invoice Format'
          handleCheck={handleCheckbox}
          value={values.invoice_shipping_detail}
        />
      </CRow>

      {/* ========== Section 8: Soft Copy (Email) ========== */}
      {
        values.invoice_shipping_detail.is_soft_copy && (
          <CRow className="mb-4">
            <FormSelectInput 
              id='recipient'
              name='recipient'
              colSize='4'
              inputLabel='Recipient'
              className='mb-3'
              selectOptions={picList}
              value={picValue}
              handleSelectInput={handleSelectPic}
              feedbackInvalid={errors?.invoice_shipping_detail?.recipient}
              invalid={errors?.invoice_shipping_detail?.recipient}
              isCreatable={true}
            />
            <FormTextInput 
              id='email_to'
              name='email_to'
              colSize='4'
              inputLabel='Email To'
              className='mb-3'
              placeholder='Enter email to'
              value={values.invoice_shipping_detail.email_to}
              handleTextInput={handleChangeShippingDetail}
              feedbackInvalid={errors?.invoice_shipping_detail?.email_to}
              invalid={errors?.invoice_shipping_detail?.email_to}
            />
            <FormDatePicker 
              id='email_date'
              name='email_date'
              colSize='4'
              inputLabel='Email Date'
              className='mb-3'
              handleOnDateChange={handleDateChangeShippingDetail}
              value={values?.invoice_shipping_detail?.email_date}
              feedbackInvalid={errors?.invoice_shipping_detail?.email_date}
              invalid={errors?.invoice_shipping_detail?.email_date}
            />
          </CRow>
        )
      }
      {
        values.invoice_shipping_detail.is_hard_copy && (
          <CRow className="mb-4">
            <FormTextInput 
              id='tracking_no'
              name='tracking_no'
              colSize='6'
              inputLabel='Tracking No'
              className='mb-3'
              placeholder='Enter tracking number'
              value={values.invoice_shipping_detail.tracking_no}
              handleTextInput={handleChangeShippingDetail}
              feedbackInvalid={errors?.invoice_shipping_detail?.tracking_no}
              invalid={errors?.invoice_shipping_detail?.tracking_no}
            />
            <FormSelectInput 
              id='courier'
              name='courier'
              colSize='3'
              inputLabel='Courier'
              className='mb-3'
              selectOptions={courierOptions}
              value={values.invoice_shipping_detail.courier}
              handleSelectInput={handleSelectCourier}
              feedbackInvalid={errors?.invoice_shipping_detail?.courier?.label}
              invalid={errors?.invoice_shipping_detail?.courier?.label}
            />
            <FormDatePicker 
              id='shipping_date'
              name='shipping_date'
              colSize='3'
              inputLabel='Shipping Date'
              className='mb-3'
              handleOnDateChange={handleDateChangeShippingDetail}
              value={values.invoice_shipping_detail?.shipping_date}
              feedbackInvalid={errors?.invoice_shipping_detail?.shipping_date}
              invalid={errors?.invoice_shipping_detail?.shipping_date}
              withTimePicker={true}
            />
          </CRow>
        )
      }
      {
        isShowFileShipping && (
          values?.file_shipping?.length > 0 ? (
            <CCol lg={isFromModal ? 12 : 6}>
              <CFormLabel>
                Shipment Receipt
              </CFormLabel>
              <FormFileThumbnail 
                name='file_shipping'
                colSize='6'
                files={values.file_shipping}
                className='justify-content-start align-items-center mb-3'
                handleViewFile={handleViewFile}
                handleConfirmDelete={handleConfirmDelete}
              />
            </CCol>
          ) :
          (
            <FormFileUpload
              name='file_shipping'
              colSize='4'
              handleFileInput={handleFileInput}
              handleFileOnDrop={handleFileInput}
              inputLabel='Shipment Receipt'
              multiple={false}
              feedbackInvalid={errors?.file_shipping}
              invalid={errors?.file_shipping}
              isSpesificImage={false}
              className={'mb-5'}
              maxFiles={1}
            />
          )
        )
      }
      {
        isShowDocumentSubmission && (
          <FormInvoicingTermsCondition
            id='invoicing_terms_condition'
            type={'checkbox'}
            colSize={12}
            className='mb-5'
            inputLabel='Document Submission'
            value={values.invoice_shipping_detail}
            handleCheck={handleCheckbox}
            handleTextInput={handleChangeShippingDetail}
            disabled={false}
            isShowMultipleUpload={true}
            handleFileInput={handleFileInput}
            handleFileOnDrop={handleFileInput}
            handleViewFile={handleViewFile}
            handleConfirmDelete={handleConfirmDelete}
          />
        )
      }
      <FormInvoiceRecipients 
        inputLabel={'Invoice Recipients'}
        className={'mb-5'}
        recipients={values.recipients}
        countryOptions={countryOptions}
        errors={errors}
        handleChange={handleChangeInvoiceRecipients}
        handleAddRecipients={handleAddInvoiceRecipients}
        handlePhoneCountry={handleSelectCountryInvoiceRecipients}
        handleRemoveRecipients={handleRemoveInvoiceRecipients}
      />
    </>
  )
}

export default AppForm